<template>
  <div class="tw-layout">
    <portal to="destination"></portal>
    <transition name="fade" mode="out-in">
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </transition>
  </div>
</template>

<script></script>

<style>
    .abnormal-notification {
        background: #FFF2E8 !important;
        border: 2px solid #FFD8BF !important;
        width: max-content !important;
    }
    .abnormal-notification .abnormal-no {
        color: #FA541C !important;
        text-decoration: underline !important;
        cursor: pointer !important;
     }
    .abnormal-notification span {
        color: black !important;
    }
</style>

<script>
import axios from "axios";
import { getLanguage } from 'src/lang';
export default {

  beforeCreate() {
    axios.patch("/v1/accounts/tmsauth").then((response) => {
      const { authentication, firstTimeLogin } = response.data.items;
      if (authentication) {
        if (firstTimeLogin) location.href = process.env.reset_password_url;
      }
    });
    // this.$store.dispatch("syncAddress");
  },
  created() {

    const goToAbnormalScreen = () => {
        let url = '/except/exceptdeal'
        let component = this.$router.match(url)
        let tab = {
            label: this.$t('public.abnormal'),
            name: component.name,
            url: this.$router.match(url),
            isActive: false,
            isEnable: true
        };
        this.$router.push(url);
        this.$store.dispatch('addToTab', tab)
        this.$store.dispatch('setTabActive', tab)
        this.$store.dispatch('setTabViewName', [tab.name, tab.name])
    };

    const applyToast = (e) => {
        const key = 'readAbnormalNotificationList';
        let readAbnormalNotificationList = JSON.parse(sessionStorage.getItem(key)) || [];

        if (!readAbnormalNotificationList.includes(e.exceptionNo)) {
           const h = this.$createElement;
           this.$notify({
              message: h('div', [
                  getLanguage() === "th"? h('span', 'เหตุการณ์หมายเลข '): h('span', 'Abnormal no. '),
                  h('span', { class: 'abnormal-no', on: {
                        click: goToAbnormalScreen
                      }
                  }, e.exceptionNo),
                  getLanguage() === "th"? h('span', ' ได้ถูกสร้างขึ้น'): h('span', ' have been created.')
             ]),
              position: 'bottom-right',
              customClass: 'abnormal-notification',
              dangerouslyUseHTMLString: true,
              duration: 5000
           });
           readAbnormalNotificationList.push(e.exceptionNo);
           sessionStorage.setItem(key, JSON.stringify(readAbnormalNotificationList));
        }
    };

    const applyToastByUser = (e) => {
        const key = 'readAbnormalNotificationUserList';
        let readAbnormalNotificationUserList = JSON.parse(sessionStorage.getItem(key)) || [];

        if (!readAbnormalNotificationUserList.includes(e.exceptionNo + e.confirmDate)) {
           const h = this.$createElement;
           this.$notify({
              message: h('div', [
                  getLanguage() === "th"? h('span', 'เหตุการณ์หมายเลข '): h('span', 'Abnormal no. '),
                  h('span', { class: 'abnormal-no', on: {
                        click: goToAbnormalScreen
                      }
                  }, e.exceptionNo),
                  getLanguage() === "th"? h('span', ' ได้ถูกมอบหมายให้คุณ'): h('span', ' has been assigned to you. ')
             ]),
              position: 'bottom-right',
              customClass: 'abnormal-notification',
              dangerouslyUseHTMLString: true,
              duration: 5000
           });
           readAbnormalNotificationUserList.push(e.exceptionNo + e.confirmDate);
           sessionStorage.setItem(key, JSON.stringify(readAbnormalNotificationUserList));
        }
    };

    // setInterval(() => {
    //           axios.get("/v1/exceptionwarns/notification").then(res => res.data.items.forEach(applyToast));
    //           let userInfoCatch  = JSON.parse(localStorage.getItem('userInfoCatch'));
    //           axios.get("/v1/exceptionwarns/notification/" + userInfoCatch.pId).then(res => res.data.items.forEach(applyToastByUser));
    // }, 30000);

    console.log("Abnormal notification has been registered.");
  },
};
</script>

<style lang="scss">
.tw * {
  &:not(i):not([class*="el-icon"]) {
    font-family: "IBM Plex Sans Thai" !important;
  }
}

.tw-layout {
  height: 100vh;
  overflow: hidden;
}
#map {
  div[style*="crosshair"] {
    cursor: url("~src/assets/img/common/plus.png"), crosshair !important;
  }
}
</style>



// WEBPACK FOOTER //
// App.vue?88023ec2